<template>
	<div>
		<template v-if="Channel.Theme.Images && Channel.Theme.Images.Logo">
			<img :src="Channel.Theme.Images.Logo" :style="logoWidth" />
		</template>
		<div>
			<span>{{ Channel.Address.Venue.Name }}</span><br />
			{{ Channel.Address.Venue.AddressLine1 }}<br />
			{{ Channel.Address.Venue.PostalCode }} {{ Channel.Address.Venue.City }}<br />
		</div>
	</div>
</template>

<script>
	import baseMixin from "@/mixins/base";
	export default {
		mixins: [baseMixin],
	}
</script>